import { OpenBankingAccount } from '@features/openBanking/types/openBankingAccount'
import { isOpenBankingAccountDeleted } from '@features/openBanking/utils/isOpenBankingAccountDeleted'

import { SyncStatus } from '../enums/syncStatus'

export function getOpenBankingAccountStatus(account: OpenBankingAccount): SyncStatus {
  const requiresUpdate = account.connection.requiresUpdate

  if (isOpenBankingAccountDeleted(account)) {
    return SyncStatus.ConnectionDeleted
  }
  if (requiresUpdate || account.isOrphaned) {
    return SyncStatus.NeedsRenewal
  }

  return SyncStatus.Synced
}
